// de_pms_checkin_stay.ts
// Tłumaczenia dla PMS.Checkin.tsx i PMS.Stay.tsx (oba ekrany Front Desk)

export const dePmsCheckinStay = {

  // ── Zameldowanie (Checkin) ────────────────────────────────────────────────
  checkin: {
    title:               "Rezeption",
    arrivalsToday:       "Anreisen heute",
    preCheckIn:          "Pre-Check-in",
    earlyCheckIn:        "Frueher Check-in",
    depositRule:         "Kautionsregel",
    depositRuleRequired: "Die Kautionsregel ist erforderlich.",
    documentType:        "Dokumententyp",
    passport:            "Reisepass",
    idCard:              "Personalausweis",
    preauth:             "Preautorisierung",
    searchPlaceholder:   "Name, Buchungsnummer, Zimmer, Telefon, E-Mail",
    readyRoom:           "Bereites Zimmer",
    noReadyRoom:         "Kein bereites Zimmer",
    noRoom:              "Kein Zimmer",
    missing:             "Fehlend",
    garage:              "Garage",
    messages: {
      completed:          "Check-in abgeschlossen. Schluesselkodierung ist bereit.",
      completedSimple:    "Check-in abgeschlossen.",
      failed:             "Zameldowanie nieudane.",
      documentRegistered: "Gaestedokument registriert und verifiziert.",
      documentFailed:     "Dokumentenregistrierung fehlgeschlagen.",
    },
  },

  // ── Zarządzanie pobytem (Stay) ────────────────────────────────────────────
  stay: {
    title:       "Aufenthaltsverwaltung",
    description: "Check-ins, Aufenthalte, Zimmerwechsel, Late Checkout und Checkout in einer Ansicht.",
    inHouseStays:"In-house-Aufenthalte",
    frontOffice: "Front Office",
    frontOfficeActions:"Front-Office-Aktionen",
    checkoutSettlement:"Checkout-Abrechnung",
    selectStay:  "Waehle einen Aufenthalt einmal aus und fahre dann mit Late Checkout, Zimmerwechsel oder Checkout fort.",
    keepVisible: "Anreisen und Aktivitaet sichtbar halten, ohne Seiten zu wechseln.",
    lateCheckout: {
      title:         "Spaeter Check-out",
      description:   "Aktive Aufenthalte verlaengern und die Gebuehr auf das Folio buchen.",
      applied:       "Spaeter Check-out angewendet",
      workflowActive:"Late-Checkout-Workflow aktiv. Der aktive Aufenthalt ist bereits vorausgewaehlt.",
    },
    roomMove: {
      title:         "Zimmerwechsel",
      description:   "Gast in ein anderes bereites Zimmer verlegen und einen neuen Schluessel ausgeben.",
      completed:     "Zimmerwechsel abgeschlossen und neuer Schluessel ausgegeben.",
      failed:        "Przeniesienie pokoju nieudane.",
      selectRoom:    "Waehle vor dem Zimmerwechsel ein bereites Zimmer aus.",
    },
    checkout: {
      title:         "Check-out",
      settle:        "Folio abrechnen, Rechnung drucken oder per E-Mail senden und dann Checkout abschliessen.",
      failed:        "Wymeldowanie nieudane.",
      settled:       "Checkout abgerechnet und Rechnung erstellt.",
      workflowActive:"Checkout-Workflow aktiv. Folio pruefen und Aufenthalt schliessen.",
    },
  },

} as const;

export default dePmsCheckinStay;
